import React from "react";
import Modal, { ModalProps, modalClasses } from "@mui/joy/Modal";

import {
	Container,
	ModalDialog,
	IconButton,
	ModalClose,
	Sheet,
	Box,
	Tabs,
	Stack,
	Divider,
	ModalOverflow,
	Button,
	Chip,
	TabList,
	Typography,
	TabPanel,
} from "@mui/joy";
import { ArrowBack } from "@mui/icons-material";
import useBuilderContainer from "../../BuilderStore";
import Helpers from "../../../../../utils/Helpers";
import { FieldsRouter, Children } from "./partials";
import Tab, { tabClasses } from "@mui/joy/Tab";
import { useTranslation } from "react-i18next";
import useMediaQuery from "@mui/material/useMediaQuery";

const Editor = () => {
	const matches = useMediaQuery("(max-width:600px)");
	const { t } = useTranslation();
	const {
		selected,
		setSelected,
		contentState,
		config,
		parent,
		mainParent,
		setMainParent,
	} = useBuilderContainer.useContainer();

	const [element, setElement] = React.useState(null);
	const [fields, setFields] = React.useState([]);

	React.useEffect(() => {
		if (selected) {
			const el = Helpers.deepArraySearch(contentState, selected);
			switch (el.type) {
				case "category":
					setFields(config?.mainCategory?.editor?.fields);
					break;
				case "sub-category":
					setFields(config?.subCategory?.editor?.fields);
					break;
				case "element":
					setFields(config?.element?.editor?.fields);
					break;
			}
		}
	}, [selected]);

	React.useEffect(() => {
		console.log(selected);
	}, [selected]);

	const getEl = () => Helpers.deepArraySearch(contentState, selected);

	const modalProperties = !matches
		? {
				width: mainParent && (config?.modalSize || 700),
				position: "fixed !important",
				right: "0 !important",
				minHeight: "100vh",

				top: "0 !important",
		  }
		: {};
	return (
		<Modal
			sx={{
				".MuiModal-backdrop": {
					display: "none",
				},
				".MuiModalDialog-root": modalProperties,
			}}
			size="lg"
			open={Boolean(selected)}
			onClose={() => {
				setMainParent(null);
				setSelected(null);
			}}
		>
			<ModalOverflow>
				<ModalDialog
					aria-labelledby="layout-modal-title"
					aria-describedby="layout-modal-description"
					layout={matches && "fullscreen"}
				>
					<ModalClose
						sx={{
							zIndex: 2,
							background: "#eee",
						}}
					/>
					<Container>
						<Stack
							direction="row"
							justifyContent="center"
							spacing={3}
							sx={{ mb: 5 }}
						>
							{parent && getEl()?.type !== "category" && (
								<IconButton
									onClick={() =>
										getEl()?.type == "subCategory"
											? setSelected(mainParent)
											: setSelected(parent)
									}
								>
									<ArrowBack />
								</IconButton>
							)}
							<Typography level="h3">{getEl()?.title}</Typography>
							<Chip size="sm">
								{t(
									config?.terms[getEl()?.type] ||
										getEl()?.type,
								)}
							</Chip>
						</Stack>

						{!config?.noChilds && getEl()?.type !== "element" ? (
							<Tabs
								size="lg"
								defaultValue={1}
								sx={(theme) => ({
									"--Tabs-gap": "0px",
									overflow: "auto",
								})}
							>
								<TabList
									sx={{
										mb: 3,
										"--ListItem-radius": "0px",
										borderRadius: 0,

										[`& .${tabClasses.root}`]: {
											fontWeight: "lg",
											flex: 1,
											bgcolor: "background.body",
											position: "relative",
											[`&.${tabClasses.selected}`]: {
												color: "primary.500",
											},
											[`&.${tabClasses.selected}:before`]:
												{
													content: '""',
													display: "block",
													position: "absolute",
													bottom: -1,
													width: "100%",
													height: 2,
													bgcolor: "primary.400",
												},
											[`&.${tabClasses.focusVisible}`]: {
												outlineOffset: "-3px",
											},
										},
									}}
								>
									<Tab>
										{t(
											config?.terms["content"] ||
												"content",
										)}
									</Tab>
									<Tab>
										{t(
											config?.terms["informations"] ||
												"informations",
										)}
									</Tab>
								</TabList>

								<Divider sx={{ mb: 5 }} />
								<TabPanel
									value={0}
									sx={{
										overflow: "auto",
										height: "66vh",
									}}
								>
									<Children element={getEl()} />
								</TabPanel>
								<TabPanel value={1}>
									<FieldsRouter
										content={getEl()}
										fields={fields}
									/>
								</TabPanel>
							</Tabs>
						) : (
							<FieldsRouter content={getEl()} fields={fields} />
						)}
					</Container>
				</ModalDialog>
			</ModalOverflow>
		</Modal>
	);
};

export default Editor;
